import type { IPoint } from '@fluentui/react/lib/Utilities';
import type { FolderForestNodeType } from 'owa-favorites-types';
import type { FolderForestTreeType } from 'owa-graph-schema';
import { action } from 'satcheljs/lib/legacy';
import { default as viewStateStore } from '../store/store';
import type FolderTreeViewStateStore from '../store/schema/FolderTreeViewStateStore';

export interface FolderTreeContextMenuState {
    folderTreeViewState?: FolderTreeViewStateStore;
}

/*
 * Sets state to spawn a context menu attached to a MailFolderList folder.
 */
export let showFolderTreeContextMenu = action('showFolderTreeContextMenu')(function (
    nodeId: string,
    nodeType: FolderForestNodeType,
    folderId: string,
    anchor: IPoint,
    treeType: FolderForestTreeType,
    rootNodeId?: string,
    showRootMenu?: boolean,
    distinguishedFolderParentIds?: string[],
    state: FolderTreeContextMenuState = { folderTreeViewState: viewStateStore }
): void {
    state.folderTreeViewState.withContextMenuFolderId = folderId;
    state.folderTreeViewState.contextMenuState = {
        nodeId,
        nodeType,
        folderId,
        anchor,
        treeType,
        rootNodeId,
        showRootMenu,
        distinguishedFolderParentIds, // not populated for legacy code path
    };
});

/*
 * Sets state to close the context menu attached to a MailFolderList folder.
 */
export let hideFolderTreeContextMenu = action('hideFolderTreeContextMenu')(function (
    state: FolderTreeContextMenuState = { folderTreeViewState: viewStateStore }
): void {
    state.folderTreeViewState.withContextMenuFolderId = null;
    state.folderTreeViewState.contextMenuState = null;
});
